<template>
    <div >
      <template v-for="(propertyGroup, index) in sortedGroupedProperties" >
        <order-property-list-group-custom
            :padding-classes="paddingClasses"
            :padding-inline-styles="paddingInlineStyles"
            :key="propertyGroup.id"
            :property-group="propertyGroup">
        </order-property-list-group-custom>
      </template>
    </div>
</template>

<script>

import OrderPropertyListGroupCustom from "./OrderPropertyListGroupCustom.vue";

export default {
    name: "order-property-list-custom",
    components:
    {
      OrderPropertyListGroupCustom,
    },
    props:
    {
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
    },
    inject: {
        itemId: {
            default: null
        }
    },
    data()
    {
        return {
            activeSlide: 0,
            touchedSlides: { 0: true }
        };
    },
    mounted()
    {
      console.log('order prop list log')
      if (App.useVariationOrderProperties)
      {
          // go to first side, because variation order properties could differ between variations
          document.addEventListener("onVariationChanged", () => {
              this.activeSlide = 0;
          });
      }
    },

    computed:
    {
        sortedGroupedProperties()
        {
            const groupedProperties = JSON.parse(JSON.stringify(this.variationGroupedProperties));

            for (const group of groupedProperties)
            {
                this.sortGroupProperties(group);
            }

            return this.getSortedGroups(groupedProperties);
        },
        missingPropertyGroupIds()
        {
            if (this.variationMarkInvalidProperties)
            {
                return [...new Set(this.variationMissingProperties.map(property => property.group && property.group.id))];
            }

            return [];
        },
        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },
        // renderOrderPropertyList()
        // {
        //    return (this.$store.getters[`${this.itemId}/currentItemVariation`].filter.isSalable && this.variationGroupedProperties.length) || App.isShopBuilder;
        // },
        renderOrderPropertyList()
        {
              return true;
        },
        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },
        variationMarkInvalidProperties() {
            return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationMarkInvalidProperties;
        }
    },

    methods:
    {
        sortGroupProperties(group)
        {
            return group.properties.sort((prev, current) =>
            {
                if (prev.position > current.position)
                {
                    return 1;
                }
                if (prev.position < current.position)
                {
                    return -1;
                }

                return 0;
            });
        },
        getSortedGroups(groups)
        {
            for (const group of groups)
            {
                const lowestPosition = group.properties.reduce((prev, current) => (prev.position < current.position) ? prev : current);

                group.lowestPosition = lowestPosition.position;

                const groupId = group.group ? group.group.id : null;

                if (this.variationMarkInvalidProperties && this.missingPropertyGroupIds.includes(groupId))
                {
                    group.hasError = true;
                }
            }

            return groups.sort((prev, current) =>
            {
                if (prev.lowestPosition > current.lowestPosition)
                {
                    return 1;
                }
                if (prev.lowestPosition < current.lowestPosition)
                {
                    return -1;
                }

                return 0;
            });
        },
        slideTo(position)
        {
            if (position >= 0 && position < this.sortedGroupedProperties.length)
            {
                this.activeSlide = position;
                this.touchedSlides[this.activeSlide] = true;
            }
        }
    }
}
</script>
